/**
 * Round decimal number
 *
 * @param {number} num
 * @param {number} decimalPlaces
 * @return {number}
 */
export const roundDecimalNumber = (num: number, decimalPlaces = 1): number =>
  Math.round((num + Number.EPSILON) * 10 * decimalPlaces) / 10 * decimalPlaces;
